var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77782 15.8333V5L16.6667 2.5V13.3333M7.77782 15.8333C7.77782 16.7542 6.783 17.5 5.5556 17.5C4.32819 17.5 3.33337 16.7542 3.33337 15.8333C3.33337 14.9125 4.32819 14.1667 5.5556 14.1667C6.783 14.1667 7.77782 14.9125 7.77782 15.8333ZM16.6667 13.3333C16.6667 14.2542 15.6719 15 14.4445 15C13.2171 15 12.2223 14.2542 12.2223 13.3333C12.2223 12.4125 13.2171 11.6667 14.4445 11.6667C15.6719 11.6667 16.6667 12.4125 16.6667 13.3333ZM7.77782 8.33333L16.6667 5.83333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNote);
export default __webpack_public_path__ + "static/media/sidebar-note.c27a7865b762a2fc08ad50c3793961bc.svg";
export { ForwardRef as ReactComponent };